import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NavigationService } from '../../../services/navigation.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-locked-content-modal',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './locked-content-modal.component.html',
  styleUrl: './locked-content-modal.component.scss',
})
export class LockedContentModalComponent {
  constructor(
    private activeModale: NgbActiveModal,
    private navigationService: NavigationService,
  ) {}

  goToHome() {
    this.activeModale.close('cancel');
  }
}
